import React, { Component } from 'react';
import Footer from '../Footer';
import { Link } from "react-router-dom";
import errorImage from '../../images/error.png';
import Navbar from '../Navbar';

export default class NotFound extends Component {

    
    handleBack = () => {
        const { history } = this.props;
        if (document.referrer && document.referrer.includes(window.location.hostname)) {
          history.goBack();
        } else {
          history.push('/'); // nebo jiná stránka
        }
      };

      
    renderHeader = () => {
        return(
            <header className="detail-header">
                <div className="header-overlay">
                <Navbar/>
        
        
                <div className="sd-container ">
                <section id="section-sub-header">
                            <div className="col-md-12 d-flex justify-content-between section-title"> 
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h6 className="sub-header-caption text-uppercase title-border-radius link">404!</h6>
                                    </div>
                                <span className='back-button link' onClick={this.handleBack}><i className='fa ml-2 fa-chevron-left'></i> Zpět</span>          
                            </div>                        
                    </section>
                </div>
                </div>
            </header> 
        );
    }

    renderMainContainer = () => {
        return(
            <section id="main-container">
                <div className="sd-container">
                    <div className="detail-content detail-content-padding">
                        <div id='error'>
                            <img src={errorImage} className="m-3 error-image" alt="Error" />
                            <h1 className="notFoundTitle">Stránka nenalezena</h1>
                            <p className="notFoundDesc">
                                Je nám líto, ale požadovaná stránka nebyla nalezena.
                                <br/>
                                <br/>
                                Ujistěte se, že jste zadali URL adresu správně.
                                <br/>
                                Je možné, že byla stránka přemístěna nebo odstraněna
                                <br/>
                                <br/>
                                K pokračování prohlížení webu použijte navigaci nebo se vraťte na úvodní stránku.
                            </p>

                            <div className="d-flex justify-content-between align-items-center">
                                <Link
                                to={'/'}
                                className="home-btn-link"
                                >
                                    <div className="trapezoid sd-pointer d-flex align-items-center">
                                        <span className='w-100'>
                                        Hlavní stránka
                                        <i className="fa fa-chevron-right ml-2"></i>
                                        </span>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </section>
        );
    }

    renderFooter = () => {
        return(
            <footer className="footer-section-height">
                <div className="sd-container">
                    <section id="footer-content" className="footer-top-padding footer-top-padding-contact">
                        <Footer/>
                    </section>
                </div>
            </footer>           
        );
    }

    render() {
        return (
            <section id="web">
                <div className="wrapper">
                    {this.renderHeader()}

                    {this.renderMainContainer()}

                    {this.renderFooter()}
                </div>
            </section>        
        );
    }
}